import Axios from "axios";

// Contrato comum: template (blob), validate e apply (ImportacaoExcelResultadoDTO).
export function createExcelImportService(resource, modo = "cadastro") {
  const base = `${resource}/import${modo === "atualizacao" ? "/update" : ""}`;
  const sendFile = (action, file) => {
    const payload = new FormData();
    payload.append("file", file);
    return Axios.post(`${base}/${action}`, payload);
  };
  return {
    generateImportTemplate: (options = {}) =>
      modo === "atualizacao"
        ? Axios.post(`${base}/template`, options.filtro || {}, {
            responseType: "blob",
          })
        : Axios.get(`${base}/template`, { responseType: "blob" }),
    listImportRecords: (filtro, params) =>
      Axios.post(`${base}/records`, filtro, { params }),
    validateImport: (file) => sendFile("validate", file),
    applyImport: (file) => sendFile("apply", file),
  };
}
